import React from 'react';
import CorrectSquareSolid from '@learningblocks/exp-constants/lib/Icons/correct-square-solid';
import InCorrectSquareSolid from '@learningblocks/exp-constants/lib/Icons/incorrect-square-solid';
import {Colours} from '@learningblocks/storybook-components';

const CORRECT_ICON_STYLE = {
  fill: Colours.colorFeedbackSuccess,
  height: '100%',
};
const INCORRECT_SELECT_ICON_STYLE = {
  fill: Colours.colorFeedbackFail,
  height: '100%',
};
const INCORRECT_ICON_STYLE = {
  fill: Colours.colorNeutralGray4,
  height: '100%',
};

export const CorrectSolidIcon = () => (
  <CorrectSquareSolid style={CORRECT_ICON_STYLE} />
);
export const InCorrectSolidIcon = () => (
  <InCorrectSquareSolid style={INCORRECT_SELECT_ICON_STYLE} />
);
export const InCorrectSolidInvalid = () => (
  <InCorrectSquareSolid style={INCORRECT_ICON_STYLE} />
);
